import { render, staticRenderFns } from "./DialogIncassi.vue?vue&type=template&id=10bdb80b"
import script from "./DialogIncassi.vue?vue&type=script&lang=js"
export * from "./DialogIncassi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports